// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"b366211f","457":"074ee3d5"}[chunkId] + ".chunk.css";
};